module.exports = __webpack_public_path__ + "img/digital-marketing-white.ac18890c.png";